import React from 'react';
import { Form, Input, Button } from 'antd';
import { FormProps } from 'antd/lib/form/Form';
import { useTranslation } from 'react-i18next';
import { formRules } from 'App/common/formRules/formRules';

interface ResetPasswordFormProps extends FormProps {
	loading: boolean;
}

const ResetPasswordForm = (props: ResetPasswordFormProps) => {
	const { t } = useTranslation(['form', 'common']);
	const { loading, ...rest } = props;
	const { password, confirmPassword } = formRules.user;

	return (
		<Form {...rest}>
			<Form.Item
				name='newPassword'
				messageVariables={{ arg: t('form:ResetPassword.Labels.NewPassword') }}
				rules={password()}
			>
				<Input type='password' placeholder={t('form:ResetPassword.Placeholders.NewPassword')} />
			</Form.Item>
			<Form.Item
				name='confirmNewPassword'
				messageVariables={{ arg: t('form:ResetPassword.Labels.ConfirmNewPassword') }}
				rules={confirmPassword('newPassword')}
			>
				<Input type='password' placeholder={t('form:ResetPassword.Placeholders.ConfirmNewPassword')} />
			</Form.Item>
			<Form.Item>
				<Button loading={loading} type='primary' htmlType='submit' size='large'>
					{t('common:Actions.Submit')}
				</Button>
			</Form.Item>
		</Form>
	);
};

export default ResetPasswordForm;
